module.exports = __webpack_public_path__ + "static/art-direction-0a7a095d3ffd817ccf0953fa4b19d3d2.jpg";